module.exports = __webpack_public_path__ + "img/lineChart.779f52a7.svg";